<app-spinner-service></app-spinner-service>

<app-toolbar-search 
  (onSearch)="applyFilterGlobal($event)" 
  placeholder="Pesquisar extratos">
  <div leftContent>
    <button pButton label="Importar Extrato" icon="pi pi-plus" (click)="importarExtrato()"></button>
  </div>
</app-toolbar-search>

<p-confirmDialog></p-confirmDialog>

<p-table #dt 
  [value]="Extratos" 
  [globalFilterFields]="['nomeBanco', 'mesAno', 'numeroConta', 'agencia']"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  class="custom-table"
  [loading]="loading"
  [rowsPerPageOptions]="[5, 10, 20, 50]">

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="nomeBanco" style="width: 25%">Banco <p-sortIcon field="nomeBanco"></p-sortIcon></th>
      <th pSortableColumn="numeroConta" style="width: 15%">Número da Conta <p-sortIcon field="numeroConta"></p-sortIcon></th>
      <th pSortableColumn="agencia" style="width: 10%">Agência <p-sortIcon field="agencia"></p-sortIcon></th>
      <th pSortableColumn="mesAno" style="width: 15%">Mês/Ano <p-sortIcon field="mesAno"></p-sortIcon></th>
      <th style="width: 8%">Tipo</th>
      <th style="width: 10%">Registros</th>
      <th style="width: 12%">Ações</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-extrato>
    <tr>
      <td>
        <div class="bank-content">
          <i class="pi pi-building bank-icon"></i>
          <span class="bank-text" [pTooltip]="extrato.nomeBanco" tooltipPosition="top">{{ extrato.nomeBanco }}</span>
        </div>
      </td>
      <td>
        <div class="account-content">
          <i class="pi pi-credit-card account-icon"></i>
          <span class="account-text" [pTooltip]="extrato.numeroConta" tooltipPosition="top">{{ extrato.numeroConta }}</span>
        </div>
      </td>
      <td>
        <div class="agency-content">
          <i class="pi pi-map-marker agency-icon"></i>
          <span class="agency-text" [pTooltip]="extrato.agencia" tooltipPosition="top">{{ extrato.agencia }}</span>
        </div>
      </td>
      <td>
        <div class="mes-ano-content">
          <i class="pi pi-calendar mes-ano-icon"></i>
          <span class="mes-ano-text" [pTooltip]="extrato.mesAno" tooltipPosition="top">{{ extrato.mesAno }}</span>
        </div>
      </td>
      <td>
        <div class="type-content">
          <span *ngIf="extrato.ehPlanilha" class="chip chip-planilha" pTooltip="Extrato importado via planilha" tooltipPosition="top">Planilha</span>
          <span *ngIf="!extrato.ehPlanilha" class="chip chip-ofx" pTooltip="Extrato importado via arquivo OFX" tooltipPosition="top">OFX</span>
        </div>
      </td>
      <td>
        <div class="records-content">
          <i class="pi pi-list records-icon"></i>
          <span class="records-text" [pTooltip]="(extrato.linhasExtratos?.length || 0) + ' transações registradas'" tooltipPosition="top">{{ extrato.linhasExtratos?.length || 0 }} registros</span>
        </div>
      </td>
      <td class="text-center">
        <div class="actions-content">
          <button pButton icon="pi pi-eye" class="p-button-rounded p-button-info action-button"
            (click)="verDetalhesListaExtrato(extrato)" pTooltip="Ver Detalhes do Extrato" tooltipPosition="top"></button>
          <button pButton icon="pi pi-pencil" class="p-button-rounded p-button-warning action-button ml-1"
            (click)="abrirEdicaoExtrato(extrato)" pTooltip="Editar contas contábeis" tooltipPosition="top"></button>
          <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger action-button ml-1"
            (click)="excluirExtrato(extrato)" pTooltip="Excluir Extrato" tooltipPosition="top"></button>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="loadingbody">
    <tr>
      <td colspan="7" class="text-center">
        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        <p>Carregando extratos...</p>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="7" class="empty-message">
        <div class="empty-content">
          <i class="pi pi-file-excel" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
          <h3>Nenhum extrato encontrado</h3>
          <p>Não há extratos importados no sistema.</p>
          <button pButton label="Importar Primeiro Extrato" icon="pi pi-plus" 
            (click)="importarExtrato()" class="p-button-raised"></button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  [(visible)]="detailsDialogVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  header="Detalhes do Extrato Bancário"
  styleClass="app-detail-dialog"
  [style]="{ width: '95vw', maxWidth: '1400px' }"
  [breakpoints]="{ '1199px': '98vw', '575px': '99vw' }"
  [contentStyle]="{ overflow: 'auto', maxHeight: '85vh', padding: '0' }">

  <div class="dialog-content-wrapper" *ngIf="selectedExtrato">
    <div class="detail-card">
      <div class="detail-header">
        <div class="header-icon"><i class="pi pi-building"></i></div>
        <div class="header-info">
          <h2 class="detail-title">{{ selectedExtrato.nomeBanco }}</h2>
          <p class="detail-subtitle">Extrato · {{ selectedExtrato.mesAno || selectedExtrato.mes + '/' + selectedExtrato.ano }}</p>
        </div>
      </div>

      <div class="info-section">
        <div class="section-title"><i class="pi pi-info-circle"></i><span>Informações do Extrato</span></div>
        <div class="detail-grid">
        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-credit-card"></i>
            <span>Número da Conta</span>
          </div>
          <div class="detail-value">{{selectedExtrato.numeroConta}}</div>
        </div>
        
        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-calendar"></i>
            <span>Período</span>
          </div>
          <div class="detail-value">{{selectedExtrato.mesAno || selectedExtrato.mes + '/' + selectedExtrato.ano}}</div>
        </div>
        
        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-map-marker"></i>
            <span>Agência</span>
          </div>
          <div class="detail-value">{{selectedExtrato.agencia}}</div>
        </div>
        
        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-calendar-times"></i>
            <span>Data Inicial</span>
          </div>
          <div class="detail-value">{{ formatarData(selectedExtrato.dataInicial) }}</div>
        </div>
        
        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-calendar-check"></i>
            <span>Data Final</span>
          </div>
          <div class="detail-value">{{ formatarData(selectedExtrato.dataFinal) }}</div>
        </div>
        
        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-file-excel"></i>
            <span>Tipo de Arquivo</span>
          </div>
          <div class="detail-value">
            <span [ngClass]="{'file-type-badge': true, 'planilha': selectedExtrato.ehPlanilha, 'ofx': !selectedExtrato.ehPlanilha}">
              {{ selectedExtrato.ehPlanilha ? 'Planilha Excel' : 'Arquivo OFX' }}
            </span>
          </div>
        </div>
        
        <div class="detail-item full-width">
          <div class="detail-label">
            <i class="pi pi-list"></i>
            <span>Total de Transações</span>
          </div>
          <div class="detail-value">
            <span class="transaction-count">{{selectedExtrato.linhasExtratos?.length || 0}} transações registradas</span>
          </div>
        </div>
      </div>
      </div>

      <div class="info-section">
        <div class="section-title"><i class="pi pi-table"></i><span>Linhas do Extrato</span></div>
        <p class="section-subtitle">Visualize todas as transações registradas neste extrato</p>
        
        <div class="table-container">
          <p-table [value]="selectedExtrato.linhasExtratos" [paginator]="true" [rows]="10" 
            [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
            [rowsPerPageOptions]="[5, 10, 20, 50]" styleClass="detail-table full-width-table"
            [lazy]="false" [totalRecords]="selectedExtrato.linhasExtratos?.length || 0">
            
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 20%; text-align: left;">Data</th>
                <th style="width: 60%; text-align: left;">Descrição</th>
                <th style="width: 20%; text-align: right;">Valor</th>
              </tr>
            </ng-template>
            
            <ng-template pTemplate="body" let-linha>
              <tr>
                <td>{{ formatarData(linha.dataOperacao) }}</td>
                <td class="description-cell">{{ linha.descricao }}</td>
                <td class="value-cell">{{ linha.valor | currency }}</td>
              </tr>
            </ng-template>
            
            <ng-template pTemplate="loadingbody">
              <tr>
                <td colspan="3" class="text-center">
                  <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                  <p>Carregando linhas do extrato...</p>
                </td>
              </tr>
            </ng-template>
            
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="3" class="empty-message">
                  <div class="empty-content">
                    <i class="pi pi-file-excel" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
                    <h3>Nenhuma linha encontrada</h3>
                    <p>Não há transações registradas neste extrato.</p>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton label="Excluir Extrato" icon="pi pi-trash" (click)="excluirExtrato(selectedExtrato!)" class="p-button-danger" *ngIf="selectedExtrato"></button>
    <button pButton label="Fechar" icon="pi pi-times" (click)="detailsDialogVisible = false" class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="editDialogVisible"
  [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
  styleClass="custom-dialog" [style]="{width: '95vw', maxWidth: '1400px'}"
  [contentStyle]="{overflow: 'auto', maxHeight: '85vh', padding: '0'}"
  (onHide)="fecharEdicaoExtrato()">

  <div class="dialog-content-wrapper extrato-details-modal" *ngIf="editExtrato">
    <div class="detail-card">
      <div class="detail-header">
        <i class="pi pi-pencil" style="color: white; font-size: 2rem; margin-right: 1rem;"></i>
        <div>
          <h2 class="detail-title">{{editExtrato.nomeBanco}}</h2>
          <p class="detail-subtitle">EDITAR CONTAS CONTÁBEIS - {{editExtrato.mesAno || editExtrato.mes + '/' + editExtrato.ano}}</p>
        </div>
      </div>

      <div class="detail-grid">
        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-credit-card"></i>
            <span>Número da Conta</span>
          </div>
          <div class="detail-value">{{editExtrato.numeroConta}}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-calendar"></i>
            <span>Período</span>
          </div>
          <div class="detail-value">{{editExtrato.mesAno || editExtrato.mes + '/' + editExtrato.ano}}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label">
            <i class="pi pi-map-marker"></i>
            <span>Agência</span>
          </div>
          <div class="detail-value">{{editExtrato.agencia}}</div>
        </div>

        <div class="detail-item full-width">
          <div class="detail-label">
            <i class="pi pi-info-circle"></i>
            <span>Instruções</span>
          </div>
          <div class="detail-value">
            Marque <strong>Alterar Conta</strong> na linha desejada para liberar a seleção da conta contábil.
            Ao salvar, os lançamentos da conta antiga serão revertidos e recriados na nova conta.
          </div>
        </div>
      </div>

      <div class="table-section">
        <div class="section-header">
          <div class="section-title">
            <i class="pi pi-table"></i>
            <span>Linhas do Extrato</span>
          </div>
          <div class="section-subtitle">
            {{ quantidadeAlteracoesPendentes }} alteração(ões) pendente(s)
          </div>
        </div>

        <div class="table-container">
          <p-table [value]="editLinhas" [paginator]="true" [rows]="10"
            [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
            [rowsPerPageOptions]="[5, 10, 20, 50]" styleClass="p-datatable-sm full-width-table"
            [lazy]="false" [totalRecords]="editLinhas?.length || 0">

            <ng-template pTemplate="header">
              <tr>
                <th style="width: 12%; text-align: left;">Data</th>
                <th style="width: 28%; text-align: left;">Descrição</th>
                <th style="width: 12%; text-align: right;">Valor</th>
                <th style="width: 12%; text-align: center;">Alterar Conta</th>
                <th style="width: 36%; text-align: left;">Conta Contábil</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-linha>
              <tr>
                <td>{{ formatarData(linha.dataOperacao) }}</td>
                <td class="description-cell">{{ linha.descricao }}</td>
                <td class="value-cell">{{ linha.valor | currency }}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="linha.permiteAlterarContaContrapartida"
                    [binary]="true"
                    (onChange)="onToggleAlterarConta(linha)"
                    pTooltip="Marque para liberar a seleção de outra conta" tooltipPosition="top">
                  </p-checkbox>
                </td>
                <td>
                  <p-dropdown [options]="contasContabeis"
                    [(ngModel)]="linha.contaContabilId"
                    optionLabel="nome"
                    optionValue="id"
                    placeholder="Selecione a conta"
                    [filter]="true"
                    filterBy="nome"
                    [showClear]="false"
                    appendTo="body"
                    styleClass="w-full"
                    [disabled]="!linha.permiteAlterarContaContrapartida">
                  </p-dropdown>
                  <small class="conta-atual-hint" *ngIf="!linha.permiteAlterarContaContrapartida">
                    Atual: {{ obterDescricaoContaLinha(linha) }}
                  </small>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" class="empty-message">
                  <div class="empty-content">
                    <h3>Nenhuma linha encontrada</h3>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>

  <p-footer>
    <button pButton label="Cancelar" icon="pi pi-times" (click)="fecharEdicaoExtrato()"
      class="p-button-secondary" [disabled]="salvandoEdicao"></button>
    <button pButton
      [label]="'Salvar alterações' + (quantidadeAlteracoesPendentes > 0 ? ' (' + quantidadeAlteracoesPendentes + ')' : '')"
      icon="pi pi-check"
      (click)="salvarEdicaoExtrato()"
      class="p-button-success"
      [disabled]="salvandoEdicao || quantidadeAlteracoesPendentes === 0"></button>
  </p-footer>
</p-dialog>
